module.exports = __webpack_public_path__ + "img/Centaurus.fd03d444.png";